import * as React from "react";
import Box from "@mui/material/Box";
import module from "../css/moduleStyle.module.css";
import styles from "../css/busOp.module.css";
import BusFuc from "../tmp/BusFuc";
import BisFacilityStatusView from 'pages/components/dashboard/SwItsBisFacilityStatus';
import { SwItsBisStationDataProvider, SwItsBisStationDataTotalInfo } from 'pages/components/dashboard/SwItsBusPssngrStation';
import BISFaultReport from "pages/components/dashboard/BISFaultReport";
import { BusCustomButtonGrp } from '../../components/button';
import TimeDisplay from '../components/TimeDisplay';
import { useEffect, useState } from "react"
import BisRouteDetailView from 'pages/components/dashboard/SwItsBisRouteDetailView'

import { useDashboard } from 'pages/components/DashboardContext';
import useNavigation from 'pages/components/UseNavigation';
import { useTranslation } from 'react-i18next';

import VideoModal from "utils/videoModal";
export default function BusOperationViewM() {
  const [showFault, setShowFault] = useState(false);

  const [videoOpen, setVideoOpen] = useState(false);
  const [videoSrc, setVideoSrc] = useState('');

  // const openDRTWindow = () => {
  //     const newWindow = window.open(
  //       'http://operation.shucle.com/',
  //       'smartWindow',
  //       'width=2000,height=2000,toolbar=no,menubar=no,scrollbars=yes,resizable=yes'
  //     );
  //     if (newWindow) {
  //       setTimeout(() => {
  //         newWindow.moveTo(4000, 4000);
  //       }, 1000);
  //     }
  //   };
  // const openBMSWindow = () => {
  //     const newWindow = window.open(
  //       'http://gbms.gg.go.kr/',
  //       'smartWindow',
  //       'width=2000,height=2000,toolbar=no,menubar=no,scrollbars=yes,resizable=yes'
  //     );
  //     if (newWindow) {
  //       setTimeout(() => {
  //         newWindow.moveTo(4000, 4000);
  //       }, 1000);
  //     }
  //   };

  const { t, i18n } = useTranslation();
  const openVideo = (src) => {
    setVideoSrc(src);
    setVideoOpen(true);
  };
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'i18nextLng' && e.newValue && e.newValue !== i18n.language) {
        i18n.changeLanguage(e.newValue);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [i18n]);

  const [currentTimeIndex, setCurrentTimeIndex] = React.useState(0);
  const [range, setRange] = React.useState('day');

  const [viewMode, setViewMode] = React.useState('total');

  const { mapMessages, clearLastMapMessage } = useDashboard();
  useNavigation(mapMessages);
  useEffect(() => {
    if (mapMessages.length > 0) {
      clearLastMapMessage();
    }
  }, [mapMessages]);

  return (
    <Box sx={{ height: "100%", width: "100%" }}>
      <VideoModal open={videoOpen} onClose={() => setVideoOpen(false)} src={videoSrc} />
      <div className="container">
        <div className="contWrap L_lmr">
          <div className="inner L_3m">
            <div className="titWrap flx a_center j_spc_btw">
              <div className="flx a_center gap20">
                <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-08)', letterSpacing: '-3px' }}>
                  {t('SuwonBusRouteWithRealTimeLocation')}
                </h2>
              </div>
              {/* <div className="flx a_center gap20">
                                <h2 className="boxTit">
                                    버스 승하차 인원 분포도
                                </h2>
                                <TimeDisplay currentTimeIndex={currentTimeIndex} range={range}/>
                            </div>
                            <BusCustomButtonGrp setViewMode={setViewMode} /> */}
            </div>
            {/* 지도영역 */}
            <div className={`${styles.boxCont_busOp} ${styles.busRoutBox_busOp} boxCont`}>
              <BisRouteDetailView />
            </div>
            {/* <div className={`${styles.boxCont_busOp} boxCont`}> */}
            {/* <BusFuc viewMode={viewMode} currentTimeIndex={currentTimeIndex} setCurrentTimeIndex={setCurrentTimeIndex}/> */}
            {/* </div> */}
          </div>
          <div className="L_3m L_tb">
            <div className="inner L_d flx_col">
              <SwItsBisStationDataProvider>
                <SwItsBisStationDataTotalInfo />
              </SwItsBisStationDataProvider>
            </div>
            <div className="inner L_d flx_col">
              <div className="titWrap flx a_center j_spc_btw">
                <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-04)' }}>
                  {showFault ? t('BIS 장애 유형별 조회') : t('BISEquipmentOperationStatus')}
                </h2>
                <button className="srchBtn" onClick={() => setShowFault(!showFault)}>
                  {showFault ? t('시설물 상태') : t('BIS 장애 유형별 조회')}
                </button>
              </div>
              <div className="boxCont">
                {showFault ? <BISFaultReport /> : <BisFacilityStatusView />}
              </div>
            </div>
          </div>
          {/* <div className="inner L_3m flx flx_col">
                        <div className="titWrap flx a_center j_spc_btw">
                            <h2 className="boxTit">DRT</h2>
                        </div>
                        <div className={`${styles.imgBoxCont_busOp} boxCont`}>
                            <img src="/images/module/DRT.gif" alt="DRT"></img>
                        </div>
                    </div> */}
          <div className="L_3m L_tb">
            <div className="inner L_d flx_col">
              <div className="titWrap flx a_center j_spc_btw">
                {/* <h2 className="boxTit"  style={{color:'var(--iv-05)'}}>DRT (수요 응답형 똑버스)</h2> */}
                <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-05)' }}>{t('DRT')}</h2>
              </div>
              <div className={`${styles.imgBoxCont_busOp} boxCont flx gap40`}>
                {/* 텍스트박스 5비율*/}
                <div className={`${styles.L_l5_busOp} flx flx_col a_center gap20`}>
                  <p className={`${styles.boxTxt_3_busOp} innerBg flx a_center j_center`}>실시간 DRT 현재 위치 및 운행 상태 확인</p>
                  <p className={`${styles.boxTxt_3_busOp} innerBg flx a_center j_center`}>이용자 호출 기록 조회</p>
                  <p className={`${styles.boxTxt_3_busOp} innerBg flx a_center j_center`}>이용자 이용 및 예약현황</p>
                  <p className={`${styles.boxTxt_3_busOp} innerBg flx a_center j_center`}>DRT 운행 내역 확인</p>
                  <p className={`${styles.boxTxt_3_busOp} innerBg flx a_center j_center`}>운행 스케줄 관리</p>
                </div>
                <div className={`${styles.L_lr_busOp}`}>
                  <img src="/images/module/DRT.gif" alt="DRT"
                    style={{ cursor: 'pointer' }}
                    // onClick={openDRTWindow}
                    onClick={() => openVideo('/video/DRT.mp4')}
                  ></img>
                </div>
              </div>
            </div>
            <div className="inner L_d flx_col">
              <div className="titWrap flx a_center j_spc_btw">
                <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-07)' }}>{t('BusManagementSystem')}</h2>
              </div>
              <div className={`${styles.imgBoxCont_busOp} boxCont flx gap40`}>
                {/* 텍스트박스 5비율*/}
                <div className={`${styles.L_l5_busOp} flx flx_col a_center gap20`}>
                  <p className={`${styles.boxTxt_3_busOp} innerBg flx a_center j_center`}>수원시 시군간 이동량 통계</p>
                  <p className={`${styles.boxTxt_3_busOp} innerBg flx a_center j_center`}>수원시 차량 운행률</p>
                  <p className={`${styles.boxTxt_3_busOp} innerBg flx a_center j_center`}>시군별 준수율 통계</p>
                  <p className={`${styles.boxTxt_3_busOp} innerBg flx a_center j_center`}>수원시 노선 운행률</p>
                  <p className={`${styles.boxTxt_3_busOp} innerBg flx a_center j_center`}>수원시 정류소 통계</p>
                </div>
                <div className={`${styles.L_l5_busOp}`}>
                  <img src="/images/module/BMS.png"
                    alt="bms"
                    style={{ cursor: 'pointer' }}
                    onClick={() => openVideo('/video/BMS.mp4')}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Box>
  );
}
